// Widget Scripts
import splashPage from './js/splashPage.js';
import cardWidget from './js/widgets/cardWidget.js';
import seo from './js/widgets/seo.js';
 import mainFeatureSlide from './js/widgets/mainFeatureSlide.js';
 import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
 import cardsSection from './js/widgets/cardsSection.js';
 import * as socialNetworkWidget from './js/widgets/socialNetworkWidget';
 import * as fairSocialNetworkWidget from './js/Fairhome/fairSocialNetworkWidget.js';
  import cardWidgetMap from './js/widgets/cardWidgetMap';
  import sponsorWidgetContainer from './js/widgets/cssSponsors.js';
  import fairmanagedLogo from './js/Fairhome/FaircardWidgetLogo.js';
  import faircountdownSlideshow from './js/Fairhome/FaircountdownSlideshow.js';
  import FairmainFeatureSlide from './js/Fairhome/FairmainFeatureSlide.js';
  import faircards from './js/Fairhome/faircards.js';
  import fairseo from './js/Fairhome/fairseo.js';
  import fairSponsors from './js/Fairhome/faircssSponsors.js';
 import mutischeduleBackground from './js/widgets/mutischeduleBackground.js';
  import faircardWidgetMap from './js/Fairhome/faircardWidgetMap.js';

// Custom Theme Scripts
import './js/localjs.js';
const docReferrer = document.referrer;
const urlVar = window.location.search;
if (docReferrer.includes('ozarkempirefair.saffirereview.com') && (window.location.pathname === '/') || urlVar === '?th=oncenter' || urlVar.includes('th=oncenter')) {
  sessionStorage.setItem('siteTheme', 'Oncenter');
}

if (docReferrer.includes('ozarkempirefair.saffirereview.com/p/fair')  || urlVar.includes('th=amphitheater') || urlVar.includes('t=amphitheater')) {
  sessionStorage.setItem('siteTheme', 'Amphitheater');
  if (window.location.pathname === '/') {
    window.location.href = `${SITEBASEURL}p/amphitheater`;
  }
}
let siteTheme = sessionStorage.getItem('siteTheme');
const hasOncClass = $('body').hasClass('site-oncenter');
const hasAmpClass = $('body').hasClass('site-amphitheater');
const path = window.location.pathname;
const ampHomepage = path === '/p/amphitheater' ? true : false;


if ((path === '/') && (siteTheme === 'Amphitheater')) {
  siteTheme = 'Oncenter';
  sessionStorage.setItem('siteTheme', 'Oncenter');
}
if (ampHomepage && (siteTheme === 'Oncenter')) {
  siteTheme = 'Amphitheater';
  sessionStorage.setItem('siteTheme', 'Amphitheater');
}


if (hasAmpClass) {
  $('body').removeClass('site-oncenter');
  sessionStorage.setItem('siteTheme', 'Amphitheater');
  siteTheme = 'Amphitheater';
} 

if (hasOncClass) {
  $('body').removeClass('site-amphitheater');
  sessionStorage.setItem('siteTheme', 'Oncenter');
  siteTheme = 'Oncenter';
}

if (!hasAmpClass && !hasOncClass) {
  if (siteTheme === 'Oncenter') {
    $('body').addClass('site-oncenter');
  }
  if (siteTheme === 'Amphitheater') {
    $('body').addClass('site-amphitheater');
  }
  if (siteTheme === null) {
    $('body').addClass('site-oncenter');
    console.log(siteTheme)
    siteTheme = 'Oncenter';
    // splashPage();
  }
}

console.log(siteTheme)
window.siteTheme = siteTheme;

if (ampHomepage) {
  $('body').addClass('amp-homepage');
}
$(document).ready(function() {
  faircountdownSlideshow();
  if ($('body').hasClass('fair-home')) {
  fairmanagedLogo(); 
  FairmainFeatureSlide();
  faircards();
  fairseo();
  // footerinfo();
  fairSponsors();

  }
})
$(window).load(function () {
  if ($('body').hasClass('fair-home')) {
    fairSocialNetworkWidget.facebookfeed(true);  
    fairSocialNetworkWidget.Mapcontainer(true);
    faircardWidgetMap();  
    fairSocialNetworkWidget.instafeed(true);}       
})

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    cardWidget();    
    seo();
    multiScheduleFeature();
    mainFeatureSlide();
    cardsSection();
    sponsorWidgetContainer();
    mutischeduleBackground();
    $(window).load(function () {
      socialNetworkWidget.facebookfeed(true);    
      cardWidgetMap();
      socialNetworkWidget.Mapcontainer(true);
      socialNetworkWidget.instafeed(true);
     
    })
   
   
  });
}